import { render, staticRenderFns } from "./_cate_id.vue?vue&type=template&id=3254ff09&scoped=true"
import script from "./_cate_id.vue?vue&type=script&lang=js"
export * from "./_cate_id.vue?vue&type=script&lang=js"
import style0 from "./_cate_id.vue?vue&type=style&index=0&id=3254ff09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3254ff09",
  null
  
)

export default component.exports